export const MIN_PRODUCT_SUGGEST = 3
export const MAX_PRODUCT_SUGGEST = 6
